export default `
  mutation ConfirmPlanModification($id: ID!) {
    confirmPlanModification(id: $id)
  }
`;
